export enum ValueFieldError {
  MISSING_IN_SOURCE = 'MISSING_IN_SOURCE',
  MISSING_IN_TARGET = 'MISSING_IN_TARGET',
  INACCESSIBLE_IN_SOURCE = 'INACCESSIBLE_IN_SOURCE',
  INACCESSIBLE_IN_TARGET = 'INACCESSIBLE_IN_TARGET',
  UNWRITABLE_IN_TARGET = 'UNWRITABLE_IN_TARGET',
}

export interface ValueFieldResponse {
  fullyQualifiedName: string;
  sobject: string;
  field: string;
  errors: ValueFieldError[];
}

export interface ValueField {
  fullyQualifiedName: string;
  sobject: string;
  field: string;
  errors: string[];
}

export type ListValueFieldsResponse = ValueFieldResponse[];

export enum FilterRecordType {
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
}
interface FilterRecordSelectOption {
  value: string;
  label: string;
}

export interface FilterRecord {
  field: string;
  type: FilterRecordType;
  options?: FilterRecordSelectOption[];
}

export interface CompareOptions {
  customValueFields?: string[];
}
